import { Record as record } from 'immutable';
import Joi from 'joi';

import ValidationMixin from '../ValidationMixin';
import { CONSENTS } from '../../constants/AppConstants';
import { construct, fields } from '../../helpers/LinkMapper';
import { Validation } from '../../constants/AppConstants';
import { translate as t } from '../../lib/I18n';

export const defaultConsents = {
    [CONSENTS.PHONE]: '',
    [CONSENTS.EMAIL_MARKETING]: false,
    [CONSENTS.PUSH_MARKETING]: false,
    [CONSENTS.SMS_Marketing]: false,
    [CONSENTS.OVER_16]: false,
};

class ConsentsForm extends record(defaultConsents) {

    static fromJSON(json = {}) {
        return construct(ConsentsForm, json, {
            [CONSENTS.PHONE]: fields.number,
            [CONSENTS.EMAIL_MARKETING]: fields.boolean,
            [CONSENTS.PUSH_MARKETING]: fields.boolean,
            [CONSENTS.SMS_Marketing]: fields.boolean,
            [CONSENTS.OVER_16]: fields.boolean,
        });
    }

    getSchema() {
        if (!this.get(CONSENTS.SMS_Marketing)) {
            return {};
        }

        return {
            [CONSENTS.PHONE]:
                Joi
                    .string()
                    .trim()
                    .regex(Validation.telephone)
                    .min(10)
                    .max(20)
                    .required()
                    .messages({
                'string.empty': t('alertmessage.badContactNumber'),
                'string.base': t('alertmessage.badContactNumber'),
                'string.max': t('alertmessage.string.max', { num: 20 }),
                'string.pattern.base': t('alertmessage.badContactNumber'),
            })
        };
    }

    normalizeSaveConsents() {
        return {
            permissions: [
                {
                    optionId: CONSENTS.EMAIL_MARKETING,
                    selected: this.get(CONSENTS.EMAIL_MARKETING),
                },
                {
                    optionId: CONSENTS.PUSH_MARKETING,
                    selected: this.get(CONSENTS.PUSH_MARKETING),
                },
                {
                    optionId: CONSENTS.SMS_Marketing,
                    selected: this.get(CONSENTS.SMS_Marketing),
                },
            ],
            singleChoicePreferences: [
                {
                    reference: CONSENTS.OVER_16,
                    selectedChoice: this.get(CONSENTS.OVER_16)
                        ? CONSENTS.I_CONFIRM_16_YEARS_OLD
                        : CONSENTS.UNDER_16,
                },
            ],
        };
    }

    normalizeConsentsResponse ({ consents, user }) {
        if (!consents?.blocks) {
            return this;
        }
        const updatedConsents = {};
        consents.blocks.map(block => {
                switch (block.type) {
                    case CONSENTS.PERMISSIONS:
                        block.options.map(option => {
                            updatedConsents[option.optionId] = option.selected;
                        });
                        break;
                    case CONSENTS.SINGLE_CHOICE_PREFERENCE:
                        updatedConsents[CONSENTS.OVER_16] =
                            block.selectedChoice === CONSENTS.I_CONFIRM_16_YEARS_OLD;
                        break;
                }
            });

        if (!this[CONSENTS.PHONE] && user.telephoneNumber) {
            updatedConsents[CONSENTS.PHONE] = user.telephoneNumber;
        }
        return this.merge(updatedConsents);
    }
}

Object.assign(ConsentsForm.prototype, ValidationMixin);

export default ConsentsForm;
